/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ObjectStorageDestination } from '../models/ObjectStorageDestination';

export class RestoreBucketRequest {
  'destination': ObjectStorageDestination;
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "destination",
      "baseName": "destination",
      "type": "ObjectStorageDestination",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreBucketRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

